export const sideOrdersPriceCount = (
  priceOfSideOrders: number,
  priceOfSideOrdersMenuConf: number
) => {
  if (priceOfSideOrdersMenuConf) {
    //Menu Configuration
    return priceOfSideOrdersMenuConf;
  }
  //Standard
  return priceOfSideOrders;
};
